import { render, staticRenderFns } from "./NavigationRail.vue?vue&type=template&id=55f40aaf&scoped=true"
import script from "./NavigationRail.vue?vue&type=script&lang=ts"
export * from "./NavigationRail.vue?vue&type=script&lang=ts"
import style0 from "./NavigationRail.vue?vue&type=style&index=0&id=55f40aaf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f40aaf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
installComponents(component, {VBtn,VIcon,VImg,VList,VListItem,VNavigationDrawer})
